import allClaimsContainerTemplate from 'views/claims-and-accounts/claims/all-claims-container.html';

export class AllClaimsContainerComponent implements ng.IComponentOptions {
  public templateUrl: string;

  constructor() {
    this.templateUrl = allClaimsContainerTemplate;
  }
}
